import { getUTMParams } from '../features/quickstart/utils/utmCapture';

const DEFAULT_UTM_SOURCE = 'playcastlanding';

export const buildHostsUrl = (): string => {
  const utms = getUTMParams();
  const params = new URLSearchParams();
  params.set('utm_source', utms.utm_source || DEFAULT_UTM_SOURCE);
  if (utms.utm_medium) params.set('utm_medium', utms.utm_medium);
  if (utms.utm_campaign) params.set('utm_campaign', utms.utm_campaign);
  if (utms.utm_term) params.set('utm_term', utms.utm_term);
  if (utms.utm_content) params.set('utm_content', utms.utm_content);
  return `/hosts?${params.toString()}`;
};
